<!--
 * @Description:
 * @Author: elliot_cj
 * @Date: 2019-01-11 11:36:59
 * @LastEditors: elliot_cj
 * @LastEditTime: 2019-01-19 16:53:14
 -->
<template>
    <PopupPanel
            :show="show"
            position="bottom"
            radius="5px"
            height="80%"
            type="area"
            title="请选择区域"
            @panel="panelClick"
    >
        <div class="panel-area-list">
            <ul v-for="(model, index) in areas" :key="index">
                <TreeMenu :model="model"  @item="panelClick"></TreeMenu>
            </ul>
        </div>
    </PopupPanel>
</template>

<script>
import PopupPanel from "./PopupPanel";
import TreeMenu from "./TreeMenu";
import { Search } from "vant";

export default {
  props: {
    show: { type: Boolean, default: false },
    areas: { type: Array, required: false }
  },
  components: {
    PopupPanel,
    TreeMenu,
    Search
  },
  methods: {
    panelClick(data) {
      this.$emit("panel", "area", data);
    },
    deviceSearch() {
      this.onRefresh();
    }
  }
};
</script>
<style lang="less" scoped>
.panel-area-list {
  display: flex;
  flex-direction: column;
  height: ~"calc(100% - 40px)";
  overflow-y: scroll;
}
</style>
